<template>
	<div class="menu_box border_bottom_dashed" style="border-top: none;border-bottom: none;">
		<div class="flex borderBottomDashed paddingAll20">
			<div class="title_shaixuan flex_jc_center">报名结束时间</div>
			<div class="classified_content" :style="{height:show?'auto':'46px'}" ref="height">
        <div class="unfold flex_ai_center" :class="show?'unfold-red':''" @click="show=!show" v-if="height">
          <span v-show="show">收起<i class="el-icon-arrow-up"></i></span>
          <span v-show="!show">展开<i class="el-icon-arrow-down"></i></span>
        </div>
				<span v-for="(item, index) in timeList" :key="'time'+index" :class="{ pitch_on: teamIndex==index }"
              @click="send(item, index)">
					{{ item.name }}
				</span>
			</div>
		</div>
	</div>
</template>

<script>
  import {apiLabour} from "@/api/apiLabour"
	export default {
		name: "timeList",
		data() {
			return {
				timeList: [],
				teamIndex: '',
        show:true,
        height:false,
			}
		},
		watch: {},
		created() {
			this.getTimeList()
		},
		methods: {
      /** @name 获取报名结束时间 */
      async getTimeList() {
        if(!this.$store.state.HC_timeList){
          let res = await apiLabour.getTime()
          if (res && res.data && res.data.code === 0) {
            this.timeList = res.data.result
            this.$store.state.HC_timeList= res.data.result
          }
        }else{
          this.timeList = this.$store.state.HC_timeList
        }
        this.$nextTick(v=>{
          this.height=this.$refs.height.offsetHeight>46;
          this.show=!this.height;
        })
      },
			/** @name 搜索单项 */
			send(obj, key) {
        this.teamIndex = key;
        if(key==0){
          this.$parent.$refs.screen.timeList=[]
          return
        }
        obj.key = key;
				//替换搜索项
				let type = this.$parent.$refs.screen.timeList.length;
				if (type) {
					this.$parent.$refs.screen.timeList.splice(0, 1, obj)
					return
				}
				//添加搜索项
				this.$parent.$refs.screen.timeList.push(obj)
			},
			/** @name 清队单项 */
			close(item) {
				this.teamIndex = ''
			},
			/** @name 清空所有 */
			closeall() {
				this.teamIndex = ''
			}
		},
	}
</script>

<style scoped>

</style>
